var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.3335H6V9.66683C6.49092 9.66683 6.88889 10.0648 6.88889 10.5557V11.8891C6.88889 11.9922 6.88889 12.0438 6.89016 12.0874C6.93638 13.6758 8.21321 14.9527 9.80163 14.9989C9.84525 15.0002 9.89683 15.0002 10 15.0002C10.1032 15.0002 10.1547 15.0002 10.1984 14.9989C11.7868 14.9527 13.0636 13.6758 13.1098 12.0874C13.1111 12.0438 13.1111 11.9922 13.1111 11.889V10.5557C13.1111 10.0648 13.5091 9.66683 14 9.66683V8.3335ZM9.1375 10.5555C9.1375 10.4174 9.02557 10.3055 8.8875 10.3055C8.74943 10.3055 8.6375 10.4174 8.6375 10.5555V12.7777C8.6375 12.9158 8.74943 13.0277 8.8875 13.0277C9.02557 13.0277 9.1375 12.9158 9.1375 12.7777V10.5555ZM11.3597 10.5555C11.3597 10.4174 11.2478 10.3055 11.1097 10.3055C10.9717 10.3055 10.8597 10.4174 10.8597 10.5555V12.7777C10.8597 12.9158 10.9717 13.0277 11.1097 13.0277C11.2478 13.0277 11.3597 12.9158 11.3597 12.7777V10.5555Z",
    fill: "#FD1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22999 7.29647C9.27557 7.21142 9.37601 7.13626 9.51573 7.08266C9.65544 7.02906 9.82663 7 10.0027 7C10.1788 7 10.35 7.02905 10.4897 7.08266C10.6295 7.13626 10.7299 7.21142 10.7755 7.29647",
    stroke: "#FD1C1C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDelete);
export default __webpack_public_path__ + "static/media/circle-delete.87e28ce9f4a30bba46eb7c4c9c73a832.svg";
export { ForwardRef as ReactComponent };